import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { Button as CoreButton } from '@alfalab/core-components-button';

import styles from './styles/styles.css';
import type { TProps, IDeps } from './models';
import { Button as Component } from './button';

export const Button = createWidget<IDeps, TProps>(
    { CoreButton, styles },
    { priorityStyler: true }
)(Component);
